import { useMatch, useSearchParams } from 'react-router-dom';
import { SCREEN_ENGAGEMENT_ROUTE } from '@/routes/consts';

/**
 * True on admin engagement editor (mock controller is running) and on
 * Stage/Fan preview iframes (`?engagementId=`).
 *
 * Those surfaces subscribe to *mock* topics for mock-controller traffic
 * (start/poll) *and* keep live topic subscriptions so real admin mutations
 * still update preview and a go-live Stage together.
 *
 * Live Stage/Fan omit that query param and only use live subscriptions.
 */
export function useMockRealtimeChannel() {
  const [searchParams] = useSearchParams();
  const adminEngagementMatch = useMatch({
    path: SCREEN_ENGAGEMENT_ROUTE,
    end: false,
  });
  return Boolean(searchParams.get('engagementId') || adminEngagementMatch);
}
